<template>
  <div v-if="isAdmin" class="tw-text-lg">
    <SfRouterLink to="/sf-admin/view-as" class="tw-no-underline">
      View as someone else
    </SfRouterLink>
  </div>
  <div v-else-if="viewingAsSomeoneElse" class="tw-text-lg">
    <a href="" @click.prevent="exitViewAs" class="tw-no-underline">
      View as admin
    </a>
  </div>
</template>

<script lang="ts">
import apiCall from "@/func/net/apiCall";
import userHasRole from "@/func/user/userHasRole";
import { SfUser } from "@/types/generalTypes";
import { defineComponent } from "vue";
import SfRouterLink from "../shared/SfRouterLink.vue";

export default defineComponent({
  components: { SfRouterLink },
  computed: {
    currentUser(): SfUser | null {
      return this.$currentUser.value;
    },
    isAdmin(): boolean {
      return userHasRole(this.currentUser, "sfAdmin");
    },
    viewingAsSomeoneElse(): boolean {
      if (!this.currentUser || !this.currentUser.realUserId) {
        return false;
      }
      return this.currentUser.realUserId !== this.currentUser.id;
    },
  },
  methods: {
    async exitViewAs() {
      const resData = await apiCall("auth/exit-view-as");
      if (resData.success) {
        window.location.href = "/dashboard";
      }
    },
  },
});
</script>
